import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagML = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M33.696 1.555A24.946 24.946 0 0 0 25.001 0c-3.059 0-5.988.55-8.696 1.555L14.13 25l2.174 23.445A24.944 24.944 0 0 0 25 50c3.058 0 5.988-.55 8.696-1.555L35.87 25 33.696 1.555Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M50 25c0-10.749-6.784-19.912-16.304-23.445v46.89C43.216 44.914 50 35.75 50 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M0 25c0 10.75 6.784 19.913 16.304 23.445V1.555C6.784 5.088 0 14.251 0 25Z"
}));
FlagML.displayName = 'FlagML';
export default withFlagWrapper(FlagML);
//# sourceMappingURL=index.js.map